import React, {useEffect} from "react";
import DialogActions from "@material-ui/core/DialogActions";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import createMuiTheme from "@material-ui/core/styles/createMuiTheme";
import styled, {ThemeProvider} from "styled-components";
import useFavorites from "../../../Context/Consumers/useFavorites";
import FavoritesButton from "../../Buttons/FavoritesButton";
import ItemType from "../../../Models/ItemType";
import Employee from "../../../Models/Employee";

interface EmployeePageFooterProps {
    employee: Employee;
    dismiss: () => void;
    user: any;
    onClickFavorite: () => void;
}

const closeButtonTheme = createMuiTheme({
    overrides: {
        MuiButton: {
            outlinedSecondary: {
                color: '#C30D00',
                borderColor: '#C30D00',
                borderWidth: '2px',
                '&:hover': {
                    borderWidth: '2px',
                }
            }
        }
    }
});

const GridContainer = styled(Grid)`
  padding-left: 16px;
  padding-right: 16px;
`;

const EmployeePageFooter = (props: EmployeePageFooterProps) => {
    const {employee, dismiss, user, onClickFavorite} = props;
    const favorites: any = useFavorites();

    useEffect(() => {

    }, [favorites])

    return (
        <DialogActions>
            <GridContainer
                container
                justify={'space-between'}
                alignItems={'center'}
            >
                <Grid item>
                    <ThemeProvider theme={closeButtonTheme}>
                        <Button
                            variant={'outlined'}
                            color={'secondary'}
                            onClick={dismiss}
                        >
                            Close
                        </Button>
                    </ThemeProvider>
                </Grid>

                {user &&
                    <Grid
                        item
                        >
                        <FavoritesButton
                            onClick={onClickFavorite}
                            selected={!!(favorites && employee && favorites[ItemType.Employee] && favorites[ItemType.Employee][employee.id])}
                        />
                    </Grid>
                }
            </GridContainer>
        </DialogActions>
    );
};

export default EmployeePageFooter;